import { parseISODay, addDays } from "../../../utils/dateMath";

/**
 * Inclusive end date ("YYYY-MM-DD") of an `numWeeks`-week lookahead window that
 * begins on `startDate`. Returns "" when `startDate` is empty or malformed —
 * the case a `<input type="date">` produces while it's being cleared or edited —
 * so callers render a placeholder instead of throwing on an Invalid Date.
 */
export function computeEndDate(startDate: string, numWeeks: number): string {
  const start = parseISODay(startDate);
  if (!start) return "";
  return addDays(start, numWeeks * 7 - 1).toISOString().slice(0, 10);
}
